import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import {
  getStudent,
  getStudentSummary,
  getSubmissions,
  Student,
  StudentSummary,
  Submission,
} from "../api/client";

export default function StudentDetail() {
  const { id } = useParams<{ id: string }>();
  const [student, setStudent] = useState<Student | null>(null);
  const [summary, setSummary] = useState<StudentSummary | null>(null);
  const [submissions, setSubmissions] = useState<Submission[]>([]);

  useEffect(() => {
    if (!id) return;
    getStudent(id).then((r) => setStudent(r.data));
    getStudentSummary(id).then((r) => setSummary(r.data));
    getSubmissions(undefined, id).then((r) => setSubmissions(r.data));
  }, [id]);

  if (!student) return <div className="empty">Loading...</div>;

  return (
    <div>
      <div className="detail-header">
        <div>
          <Link to="/students" style={{ color: "var(--text-muted)", fontSize: 13 }}>&larr; Back to Students</Link>
          <h2>{student.name}</h2>
          <div style={{ color: "var(--text-muted)", fontSize: 14 }}>
            {student.phone && <span>{student.phone} &middot; </span>}
            {student.email && <span>{student.email} &middot; </span>}
            Classes: {student.classes?.map((c) => c.name).join(", ") || "None"}
          </div>
        </div>
      </div>

      <div className="summary-grid">
        <div className="stat-card">
          <div className="label">Sessions</div>
          <div className="value">{summary?.total_sessions ?? "-"}</div>
        </div>
        <div className="stat-card">
          <div className="label">Attendance</div>
          <div className="value">{summary?.attendance_rate ?? "-"}%</div>
        </div>
        <div className="stat-card">
          <div className="label">Assignments</div>
          <div className="value">{summary?.total_assignments ?? "-"}</div>
        </div>
        <div className="stat-card">
          <div className="label">Completion</div>
          <div className="value">{summary?.completion_rate ?? "-"}%</div>
        </div>
      </div>

      <h3 style={{ marginBottom: 12 }}>Submissions</h3>
      <div className="table-container">
        {submissions.length === 0 ? (
          <div className="empty">No submissions yet</div>
        ) : (
          <table>
            <thead><tr><th>Assignment</th><th>Submitted</th><th>Source</th></tr></thead>
            <tbody>
              {submissions.map((s) => (
                <tr key={s.id}>
                  <td>{s.assignment_id}</td>
                  <td>{new Date(s.submitted_at).toLocaleDateString()}</td>
                  <td><span className="badge">{s.source}</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
